import React from "react";

// RailFilterChip — the visible, removable record of the drill that is currently
// narrowing the rail (V6 §3 / §F.4). When a stage (or a barrier, a topic, a source)
// is clicked, three things happen at once: the element highlights, the rail filters
// to that population, and the DrillOver opens. This chip is the third leg's memory —
// it names the active filter at the top of the rail so the missing rows read as a
// deliberate narrowing, not as missing data. Dismissing it CLEARS ALL THREE
// (highlight, rail filter, drill); the page wires that behind `onClear`.
//
// Nothing renders when no filter is active — the rail shows its full list.
const RailFilterChip = ({ filter, onClear }) => {
  if (!filter?.label) return null;
  return (
    <button
      type="button"
      onClick={onClear}
      data-testid="rail-filter-chip"
      className="self-start inline-flex items-center gap-1.5 min-h-[44px] max-w-full px-2 rounded-md border border-[#C7E7FF] dark:border-blue-800 bg-[#EAF6FF] dark:bg-blue-900/30 text-xs font-medium text-[#1B5E86] dark:text-[#9BDBFF] transition-colors"
      title="Clear this filter"
    >
      <span className="truncate">Showing: {filter.label}</span>
      <span aria-hidden="true">×</span>
      <span className="sr-only">Clear filter</span>
    </button>
  );
};

export default RailFilterChip;
